import { call, put } from "redux-saga/effects";
import {
  fetchBalanceByWallet,
  fetchBalanceByGiftCard,
} from "../requests/giftBalance";
import {
  fetchBalanceByWalletSuccess,
  fetchBalanceByWalletFailure,
  fetchBalanceByGiftCardSuccess,
  fetchBalanceByGiftCardFailure,
} from "../../giftBalance/giftBalanceActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleFetchBalanceByWallet({ payload: { mobileNumber } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchBalanceByWallet, { mobileNumber });
    const { walletBalance } = parseWalletData(response);
    if (walletBalance) {
      yield put(fetchBalanceByWalletSuccess({ balance: walletBalance }));
    } else {
      yield put(fetchBalanceByWalletSuccess({ balance: 0 }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchBalanceByWallet error = ${error}`);
    yield put(fetchBalanceByWalletFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseWalletData = (response) => ({
  walletId: response?.data?.walletBalances?.wallet?.walletNumber,
  walletBalance: response?.data?.walletBalances?.wallet?.walletBalance,
});

const parseCardData = (response) => ({
  amount: response?.data?.amount,
  cardExpiry: response?.data?.cardExpiry,
});

export function* handleFetchBalanceByGiftCard({ payload: { cardNumber } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchBalanceByGiftCard, { cardNumber });
    const { data } = response;
    if (data?.code === "SUCCESS") {
      const { amount, cardExpiry } = parseCardData(response);
      if (amount && cardExpiry) {
        yield put(
          fetchBalanceByGiftCardSuccess({ balance: { amount, cardExpiry } })
        );
      } else {
        yield put(
          fetchBalanceByGiftCardSuccess({
            balance: { amount: 0, cardExpiry: null },
          })
        );
      }
    } else if (data?.code === "INVALID_CARDNUMBER") {
      yield put(
        fetchBalanceByGiftCardFailure({
          message: "invalidCardNumber",
        })
      );
    } else {
      yield put(
        fetchBalanceByGiftCardFailure({
          message: "somethingWentWrong",
        })
      );
    }
  } catch (error) {
    console.log(`handleFetchBalanceByGiftCard error = ${error}`);
    yield put(
      fetchBalanceByGiftCardFailure({
        message: "somethingWentWrong",
      })
    );
  }
  yield put(stopLoadingIndicator());
}
